import { Box } from "@mui/material";

/**
 * Report-type icon (a survey configuration's `image_url`). The icons are black
 * glyphs on transparent backgrounds, so dark mode inverts them to white; the
 * hue rotation keeps coloured icons close to their original hues.
 */
const ReportIcon = ({
  src,
  alt,
  size = 24,
  disabled = false,
}: {
  src: string;
  alt: string;
  size?: number;
  disabled?: boolean;
}) => (
  <Box
    component="img"
    src={src}
    alt={alt}
    sx={(theme) => ({
      width: size,
      height: size,
      objectFit: "contain",
      flexShrink: 0,
      opacity: disabled ? 0.5 : 1,
      ...theme.applyStyles("dark", { filter: "invert(1) hue-rotate(180deg)" }),
    })}
  />
);

export default ReportIcon;
